import IconBase from "./IconBase";

// Two layered surfaces: this is the switch to *another* workspace, so the glyph
// is about there being more than one, not about what a workspace contains.
const WorkspaceIcon = (props) => (
    <IconBase {...props}>
        <path d="M8 8V5a2.5 2.5 0 0 1 2.5-2.5h8A2.5 2.5 0 0 1 21 5v8a2.5 2.5 0 0 1-2.5 2.5h-3" />
        <rect x="2.5" y="8" width="13" height="13" rx="3.5" />
    </IconBase>
);

export default WorkspaceIcon;
